module.exports = __webpack_public_path__ + "media/images/lb/344-847f5e244c313f25d9d091faf30681d6.svg";